var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToilet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35939 9H15.1094C15.3083 9 15.4991 9.07902 15.6397 9.21967C15.7804 9.36032 15.8594 9.55109 15.8594 9.75C15.8594 10.7446 15.4643 11.6984 14.761 12.4017C14.0578 13.1049 13.104 13.5 12.1094 13.5H11.6609C11.594 13.5 11.5282 13.5179 11.4706 13.5519C11.4129 13.5859 11.3653 13.6347 11.3329 13.6932C11.3004 13.7518 11.2843 13.8179 11.286 13.8848C11.2878 13.9518 11.3074 14.017 11.3429 14.0737L12.5009 15.9263C12.5364 15.983 12.556 16.0482 12.5578 16.1152C12.5595 16.1821 12.5433 16.2482 12.5109 16.3068C12.4784 16.3653 12.4309 16.4141 12.3732 16.4481C12.3155 16.4821 12.2498 16.5 12.1829 16.5H4.16089C4.09395 16.5 4.02823 16.4821 3.97055 16.4481C3.91288 16.4141 3.86535 16.3653 3.8329 16.3068C3.80045 16.2482 3.78426 16.1821 3.78602 16.1152C3.78777 16.0482 3.80741 15.983 3.84289 15.9263L5.35939 13.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10938 13.5C5.11481 13.5 4.16099 13.1049 3.45772 12.4017C2.75446 11.6984 2.35938 10.7446 2.35938 9.75V3C2.35938 2.60218 2.51741 2.22064 2.79871 1.93934C3.08002 1.65804 3.46155 1.5 3.85938 1.5H9.85938C10.2572 1.5 10.6387 1.65804 10.92 1.93934C11.2013 2.22064 11.3594 2.60218 11.3594 3V9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilet);
export default __webpack_public_path__ + "static/media/toilet.9b3c7cb8b703cadce17751db07e46c0a.svg";
export { ForwardRef as ReactComponent };